/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationTitle } from '../../models/notification-title';

export interface DismissNotification$Params {
  facilityGroupId: number;
  type: NotificationTitle;
  days?: number;
  key?: string;
}

export function dismissNotification(http: HttpClient, rootUrl: string, params: DismissNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, dismissNotification.PATH, 'put');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
    rb.path('type', params.type, {});
    rb.query('days', params.days, {});
    rb.query('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

dismissNotification.PATH = '/api/notification/dismiss/{facilityGroupId}/{type}';
